import { ComponentsCustomer } from "@omni/types/components/customer/customer.model";
import { ComponentsCustomerType } from "@omni/types/components/customer/shared/customerType.enum";
import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { PhoneNumber } from "@/components/General/PhoneNumber/phoneNumber.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type StaticCustomerDetailsProps = {
    customer: ComponentsCustomer;
    onEdit: () => void;
};

const StaticCustomerDetails = ({
    customer,
    onEdit
}: StaticCustomerDetailsProps) => {
    const { t } = useGranite();

    return (
        <>
            {customer.customerType === ComponentsCustomerType.B2B && (
                <div>
                    <div>{customer.companyName}</div>
                    <div>
                        {customer.vatNrPrefix}
                        {customer.vatNr}
                    </div>
                </div>
            )}

            <div className={cn("mb-2")}>
                <div>{`${customer.firstName} ${customer.lastName}`}</div>
                <div>{customer.email}</div>
                <div>
                    <PhoneNumber
                        phoneNumber={`${customer.phonePrefix}${customer.phone}`}
                    />
                </div>
            </div>
            <Button
                test="customerDetails-button-edit"
                className={cn("px-0")}
                color="link"
                type="button"
                onClick={onEdit}
            >
                <i className={cn("las la-pencil-alt mr-2")} />
                {t("checkout.customerDetails.customerInfo.edit.link")}
            </Button>
        </>
    );
};

export { StaticCustomerDetails };
